import { useSelector } from "react-redux";
import useLocalStorage from "../../hooks/useLocalStorage";
import Select from "react-select";
import { AppState } from "../../redux/types";

const LocationModalContent = () => {
  const assignedLocation = useSelector((state: AppState) => state.user.loggedInUserData.office_assigned_data)
  const currentLocation = useSelector((state: AppState) => state.user.loggedInUserData.user_office_location_data)
  const [officeLocation, setOfficeLocation] = useLocalStorage("office-location-id", currentLocation ? currentLocation.id : 0);

  return (
    <div className="min-h-12 text-sm">
      <div className="p-1 absolute bottom-1/2">
        <label htmlFor="officeLocation" className="tqs-input-label">
          Location
        </label>
        <Select
          placeholder="Select Location"
          id="officeLocation"
          name="officeLocation"
          options={assignedLocation}
          onChange={(option: any) => setOfficeLocation(option.value)}
          value={assignedLocation.filter(option => (
            option.value === officeLocation
          ))}
        />
      </div>
    </div>
  );
};

export default LocationModalContent;
